import {
  
  ACTIVATING_CHAT_INTEGRATION_REQUEST, ACTIVATING_CHAT_INTEGRATION_SUCCEDDED, ACTIVATING_CHAT_INTEGRATION_FAILED,
  UPDATING_CHAT_INTEGRATION_REQUEST, UPDATING_CHAT_INTEGRATION_SUCCEDDED, UPDATING_CHAT_INTEGRATION_FAILED,
} from './actionTypes.jsx';
import {activatingIntegrationSuccedded} from './integrations';
import axios from 'axios';
import buildUrl from 'build-url-ts';

const apiUrl = process.env.REACT_APP_API_URL;
const INTEGRATION_BASE_URL = `${apiUrl}/api/2.0/integrations`;

export function activateAccount(configuration, integrationType){
  return function (dispatch) {
    dispatch(activatingAccount());

    let url = buildUrl(INTEGRATION_BASE_URL, {
      path: `${integrationType}`,
    });

    return axios({
      method: 'POST',
      url: url,
      data: configuration
    })
    .then((response) => {
      dispatch(activatingAccountSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
      return response.data;
    })
    .catch(error =>
      dispatch(activatingAccountFailed(error.response.data))
    )
  }
}

function activatingAccount(){
  return {
    type: ACTIVATING_CHAT_INTEGRATION_REQUEST,
    payload: {}
  }
}

function activatingAccountSuccedded(json){
  return {
    type: ACTIVATING_CHAT_INTEGRATION_SUCCEDDED,
    payload: json
  }
}

function activatingAccountFailed(error){
  return {
    type: ACTIVATING_CHAT_INTEGRATION_FAILED,
    payload: error
  }
}

/**
* Update intercom configuration
*/
export function updateConfiguration(configuration, integrationType){
  return function (dispatch) {
    dispatch(updatingConfiguration());

    let url = buildUrl(INTEGRATION_BASE_URL, {
      path: `${integrationType}`,
    });

    return axios({
      method: 'PUT',
      url: url,
      data: configuration
    })
    .then((response) => {
      dispatch(updatingConfigurationSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
    })
    .catch(error =>
      dispatch(updatingConfigurationFailed(error.errors))
    )
  }
}

function updatingConfiguration(){
  return {
    type: UPDATING_CHAT_INTEGRATION_REQUEST,
    payload: {}
  }
}

function updatingConfigurationSuccedded(json){
  return {
    type: UPDATING_CHAT_INTEGRATION_SUCCEDDED,
    payload: json
  }
}

function updatingConfigurationFailed(error){
  return {
    type: UPDATING_CHAT_INTEGRATION_FAILED,
    payload: error
  }
}


